<section class=" section contact-container">
<div class="content">
   
     
   <div class="left-col">      
      <h1>Contact us</h1>

      
      <form id="contact-form">
          <label for="name">Full name</label>
          <input type="text" id="name" name="name" placeholder="Your Full Name" required>
          <label for="email">Email Address</label>
          <input type="email" id="email" name="email" placeholder="Your Email Address" required>
          <label for="message">Message</label>
          <textarea rows="6" placeholder="Your Message" id="message" name="message" required></textarea>
          <!--<a href="javascript:void(0)">--><button type="submit" id="submit" name="submit">Send</button><!--</a>-->
    
        </form>

    </div>
    <div class="right-col">
        <img class="right-image" src="./images/contact-bg.jpg" alt="" />
    </div>
</div>
</section>

  <style>
    .contact-container {
        max-width: 114rem;
        margin: 0 auto;
        
    }
    .content {
        box-shadow: 20px 7px 32px  #cccc;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
       
    }
    .right-col {
        width: 450px;
        height: 600px;
    }
    .right-image {
        width: 100%;
        height: 100%;
    }
    .left-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 400px;
        height: 600px;
    }
    #contact-form {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    input, textarea {
        color: #010712;
        font-weight: 500;
        background: #FCFDFD;
        border: none;
        border-bottom: 1px solid #818386;
        padding: 0.5rem 0;
        margin-bottom: 1rem;
        outline: none;
    }
    h1 {
        color: #3F444C;
        text-transform: uppercase;
        font-size: 4.5rem;
        letter-spacing: 0.5rem;
        font-weight: 300;
        margin-bottom: 3rem;
    }

    p {
        color: #818386;
        font-size: 1.9rem;
        letter-spacing: 0.01rem;
        width: 40vw;
        margin: 0.25rem 0;
    }
        textarea {
        resize: none;
    }

    button {
        text-transform: uppercase;
        font-weight: 300;
        background: #3B3636;
        color: #FCFDFD;
        width: 100%;
        height: 5.25rem;
        border: none;
        border-radius: 5px;
        outline: none;
        cursor: pointer;
        margin-top: 5px;
    }

    input:hover, textarea:hover, button:hover {
        opacity: 0.5;
    }

    button:active {
        opacity: 0.8;
    }
    label {
        font-size: 2rem;
        margin: 0.25rem 0;
    }

    @media only screen and (max-width: 768px) {
        .content {
            flex-direction: column;
            padding: 5px;
            box-shadow: none;
        }
        .right-col {
            margin-top: 4rem;
            width: 100%;
            height: 400px;
        }
        .left-col {
            width: 100%;
            height: 400px;
        }
        h1 {
            font-size: 3rem;
            margin-bottom: 1rem;
        }
        p {
            font-size: 1.5rem;
            width: 100%;
        }
        input, textarea {
            width: 100%;
        }
        button {
            width: 100%;
            height: 3.5rem;
        }
    
    }

        


  </style>